'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFilter8 = function MdFilter8(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 18.4v3.2h3.4v-3.2h-3.4z m0-6.8v3.4h3.4v-3.4h-3.4z m0 13.4c-1.8 0-3.2-1.5-3.2-3.4v-2.5c0-1.4 1.1-2.5 2.5-2.5-1.4 0-2.5-1.1-2.5-2.5v-2.5c0-1.8 1.4-3.2 3.2-3.2h3.4c1.8 0 3.4 1.4 3.4 3.2v2.5c0 1.4-1.1 2.5-2.5 2.5 1.4 0 2.5 1.1 2.5 2.5v2.5c0 1.9-1.6 3.4-3.4 3.4h-3.4z m13.4 3.4v-23.4h-23.4v23.4h23.4z m0-26.8c1.8 0 3.4 1.6 3.4 3.4v23.4c0 1.8-1.6 3.2-3.4 3.2h-23.4c-1.8 0-3.2-1.4-3.2-3.2v-23.4c0-1.8 1.4-3.4 3.2-3.4h23.4z m-30 6.8v26.6h26.6v3.4h-26.6c-1.8 0-3.4-1.6-3.4-3.4v-26.6h3.4z' })
        )
    );
};

exports.default = MdFilter8;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/filter-8.js
// module id = 2868
// module chunks = 0